/**
 * Mappatura dei moduli registrati nei gruppi della sidebar.
 *
 * Ogni gruppo ha un nome, un'icona e un elenco di nomi modulo
 * (corrispondenti a ModuleEntry.nome in modules.ts).
 *
 * Ristrutturato secondo DEC-043/044/045/046.
 */

import {
  Calculator,
  FolderOpen,
  LayoutDashboard,
  Mail,
  Settings,
  ShoppingCart,
  Truck,
  Warehouse,
  type LucideIcon,
} from 'lucide-react';

export interface SidebarGroup {
  /** Nome del gruppo visualizzato nella sidebar. */
  label: string;
  /** Componente icona Lucide del gruppo (riferimento diretto: errore tsc se manca). */
  icon: LucideIcon;
  /** Nomi dei moduli (ModuleEntry.nome) che appartengono a questo gruppo. */
  moduli: string[];
}

/**
 * Gruppi sidebar ordinati per posizione.
 * Ogni modulo compare in un solo gruppo.
 */
export const sidebarGroups: SidebarGroup[] = [
  {
    label: 'Vendite',
    icon: ShoppingCart,
    moduli: ['Cassa', 'Clienti', 'Preventivi clienti', 'Contratti clienti', 'Ordini vendita', 'DDT e documenti'],
  },
  {
    label: 'Magazzino',
    icon: Warehouse,
    moduli: ['Magazzino'],
  },
  {
    label: 'Acquisti',
    icon: Truck,
    moduli: ['Fornitori', 'Richieste', 'Preventivi fornitori', 'Contratti fornitori', 'Ordini'],
  },
  {
    label: 'Contabilità',
    icon: Calculator,
    moduli: ['Fatturazione', 'Verifiche fiscali', 'Ricalcolo margini', 'Conti', 'Bonifici', 'Centri di costo', 'Commesse', 'Imputazioni'],
  },
  {
    label: 'Documenti',
    icon: FolderOpen,
    moduli: ['Archivio'],
  },
  {
    label: 'Comunicazioni',
    icon: Mail,
    moduli: ['Email'],
  },
  {
    label: 'Amministrazione',
    icon: LayoutDashboard,
    moduli: ['Dashboard', 'Andamento prezzi'],
  },
  {
    label: 'Sistema',
    icon: Settings,
    moduli: ['Utenti', 'Gruppi', 'Azienda', 'Moduli', 'Configurazione'],
  },
];
